<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 163.9 163.9"
    class="fill-current ml-0.5 -mr-0.5"
  >
    <path
      d="M35 4C20-5 8 2 8 19v126c0 17 12 24 27 15l110-63c14-8 14-22 0-30L35 4z"
    />
  </svg>
</template>
